import { Injectable } from '@angular/core';
import { AuthToken } from '../@auth/models/auth-token';
import { ApiService } from './api.service';
import { URLConfig } from '../../configs/url-config';
import { Observable, throwError } from 'rxjs';
import { IResponse } from '../@auth/models/IResponse';
import { catchError, map } from 'rxjs/operators';
 
 


@Injectable({
  providedIn: 'root',
})
export class AuthTokenService {
  private tokenKey = 'easyInvoices';
  userData: any;
  private token!: AuthToken | string;
  constructor(
    private _apiService: ApiService) {
    this.tokenKey = this.tokenKey;
     
  }
  
  refreshToken(): Observable<string> {
      this.userData = localStorage.getItem("user");
     this.userData = JSON.parse(this.userData);
    const obj = {
      token: localStorage.getItem('token'),
    };
    return this._apiService.postRequest<IResponse>(
      `${URLConfig.refreshToken}?oldtoken=${obj.token}&userId=${this.userData.userId}`,
      {}
    ).pipe(
      map((response: any) => {
        const newToken = response.data.token;
        // localStorage.setItem('token', response.data.token)
        return newToken;
      }),
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }

  getValueLocalstorage(){
    return  JSON.parse(localStorage.getItem('user'))
  }

  hasToken(): boolean {
    return this.token ? true : false;
  }

}
